import type { ApiClient } from '@/shared/api';
import type {
  ConnectAuthorizeResponseWire,
  ConnectionStatusResponseWire,
  PluginApiClient,
  SlackConnectResponseWire,
  SlackStatusResponseWire,
} from './types';

export function createPluginApi(client: ApiClient): PluginApiClient {
  return {
    async getSlackStatus(signal) {
      return client.request<SlackStatusResponseWire>({
        path: '/api/v1/integrations/slack/status',
        signal,
      });
    },
    async connectSlack(signal) {
      return client.request<SlackConnectResponseWire>({
        method: 'POST',
        path: '/api/v1/integrations/slack/connect',
        signal,
      });
    },
    async disconnectSlack(signal) {
      await client.request<void>({
        method: 'DELETE',
        path: '/api/v1/integrations/slack',
        signal,
      });
    },
    async connectProvider(provider, signal) {
      return client.request<ConnectAuthorizeResponseWire>({
        method: 'POST',
        path: `/api/v1/integrations/${encodeURIComponent(provider)}/connect`,
        signal,
      });
    },
    async getConnectionStatus(provider, signal) {
      return client.request<ConnectionStatusResponseWire>({
        path: `/api/v1/integrations/${encodeURIComponent(provider)}/status`,
        signal,
      });
    },
  };
}
